import { render, staticRenderFns } from "./FeaturedGoodList.vue?vue&type=template&id=4bdc8c06&"
import script from "./FeaturedGoodList.vue?vue&type=script&lang=js&"
export * from "./FeaturedGoodList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports